module.exports = {
    type: 'object',
    additionalProperties: false,
    properties: {
        adrOverrideId: {
            type: ['string', 'null']
        },
        adrContractLength: {
            type: ['string', 'null']
        }
    }
};
